export const COMMUNITY = {

  'NO_PROJECTS': 'We do not have projects to show at the moment.',

};
